import TerritoryProvider from './territory.provider';

export default class TerritoryService {
  constructor(private provider: TerritoryProvider) {}

  public getAvailableTerritories() {
    return this.provider.availableTerritories || [];
  }
}



// WEBPACK FOOTER //
// src/app/common/services/territory.service.ts